// extracted by mini-css-extract-plugin
export var callCard = "_r9-0";
export var callMessageButton = "_r9-1";
export var helpIcon = "_r9-3";
export var helpIconContainer = "_r9-4";
export var verticalDivider = "_r9-2";